module.exports = __webpack_public_path__ + "static/img/010.8c7cbb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/010.png
// module id = 6IX4
// module chunks = 0